module.exports = __webpack_public_path__ + "static/media/xz07_grey.b4f80ba8.png";